<obg-lazy-loader *ngIf="isReadyToLazyLoad$ | async" [lazyItem]="homeLazyModule"></obg-lazy-loader>
